import {
    _STATUS_KEY_RANGE,
    _MODE_KEY_RANGE,
    _PART_KEY_RANGE,
    _DIRECTION_KEY_RANGE,
    _EQUIPMENT_KEY_RANGE,
    _ACTIVE_ASSIST_KEY_RANGE,
    _SPEED_KEY_RANGE,
    _ELBOW_METHOD_KEY_RANGE,
    _WRIST_METHOD_KEY_RANGE,
    _KNEE_ANKLE_METHOD_KEY_RANGE,
} from '@/components/Table/static'
import * as ENUM from "@/enum/lib";
const getActiveModeAssistValues = (that, val) => {
    const a = _ACTIVE_ASSIST_KEY_RANGE.getItemByNo(val);
    return a ? that.$t(a.unit) + ' Level ' + a.title : ''
};
const getPassiveModeUnitValues = (that, val) => {
    const a = _SPEED_KEY_RANGE.getItemByNo(val);
    return a ? a.title + ' ' + that.$t(a.unit) : ''
};
export const showFixedRehabilitationDetails = (that) => {
    let exerciseStatus = that.selectedExerciseProps.exerciseStatus;
    if ((that.selectedExerciseProps.exerciseSet - that.selectedExerciseProps.exerciseCourseLength) <= 0) {
        exerciseStatus = 3;
    }

    return [
        {
            index: 0,
            keyTitle: that.$t('title'),
            keyType: 'DefaultInfoInput',
            class: 'custom-title',
            keyRange: [],
            values: that.selectedExerciseProps.exerciseGuide.exerciseGuideTitle,
            mainStyle: {
                height: '100%',
            },
        },
        {
            index: 1,
            keyTitle: that.$t('status.status'),
            keyType: 'DefaultInfoInput',
            class: _STATUS_KEY_RANGE[exerciseStatus].class,
            keyRange: [],
            values: that.$t(`status.${_STATUS_KEY_RANGE[exerciseStatus].title}`)
        },
        {
            index: 2,
            keyTitle: that.$t('rehabilitation.set'),
            keyType: 'DefaultInfoInput',
            class: '',
            keyRange: [],
            values: that.selectedExerciseProps.exerciseCourseLength + '/' + that.selectedExerciseProps.exerciseSet
        },
        {
            index: 3,
            keyTitle: that.$t('rehabilitation.due_date'),
            keyType: 'DefaultInfoInput',
            class: '',
            keyRange: [],
            values: that.moment(that.selectedExerciseProps.exerciseEndDatetime).locale(that.$t('country')).format('ll')
        },
        {
            index: 4,
            keyTitle: that.$t(`rehabilitation.equipment`),
            keyType: 'DefaultInfoInput',
            parentClass: '',
            keyRange: [],
            values: that.$t(_EQUIPMENT_KEY_RANGE.data[ENUM.EQUIPMENT[ENUM.EQUIPMENT[that.selectedExerciseProps.seqDeviceType]]].trans)
        },
        {
            index: 5,
            keyTitle: that.$t('rehabilitation.mode'),
            keyType: 'DefaultInfoInput',
            parentClass: '',
            keyRange: [],
            values: that.$t(_MODE_KEY_RANGE[that.selectedExerciseProps.exerciseGuide.exerciseGuideMode].trans)
        },
        {
            index: 6,
            keyTitle: that.$t('rehabilitation.position'),
            keyType: 'DefaultInfoInput',
            class: '',
            keyRange: [],
            values: that.$t(_PART_KEY_RANGE.data[ENUM.POSITION[ENUM.POSITION[that.selectedExerciseProps.exerciseGuide.exerciseGuidePosition]]].trans),
        },
        {
            index: 7,
            keyTitle: that.$t('rehabilitation.direction'),
            keyType: 'DefaultInfoInput',
            class: '',
            keyRange: [],
            values: that.$t(_DIRECTION_KEY_RANGE.data[ENUM.DIRECTION[ENUM.DIRECTION[that.selectedExerciseProps.exerciseGuide.exerciseGuideDirection]]].trans)
        }
    ];
};

export const showRehabilitationDetails = ( that ) => {
    let items;
    const device = that?.selectedExerciseProps?.seqDeviceType;
    const mode = that?.selectedExerciseProps?.exerciseGuide?.exerciseGuideMode;
    const position = that?.selectedExerciseProps?.exerciseGuide?.exerciseGuidePosition;

    if (device === 1) {
        items = [];

        let gripLohValue = {
            keyTitle: that.$t('rehabilitation.exercise_method'),
            values: '-',
        };

        switch (position) {
            case ENUM.POSITION.ELBOW :
                gripLohValue.keyTitle = that.$t('rehabilitation.exercise_method');
                gripLohValue.values = that.selectedExerciseProps.exerciseGuide.exerciseGuideHandGripType !== 0 ? that.$t(_ELBOW_METHOD_KEY_RANGE[that.selectedExerciseProps.exerciseGuide.exerciseGuideHandGripType - 1].trans) : '-';
                break;
            case ENUM.POSITION.WRIST :
                gripLohValue.keyTitle = that.$t('rehabilitation.exercise_method');
                gripLohValue.values = that.selectedExerciseProps.exerciseGuide.exerciseGuideHandGripType !== 0 ? that.$t(_WRIST_METHOD_KEY_RANGE[that.selectedExerciseProps.exerciseGuide.exerciseGuideHandGripType - 1].trans) : '-';
                break;
            case ENUM.POSITION.KNEE :
            case ENUM.POSITION.ANKLE :
                gripLohValue.keyTitle = that.$t('rehabilitation.device_height');
                gripLohValue.values = that.selectedExerciseProps.exerciseGuide.exerciseGuideDeviceLoh !== 0 ? that.$t(_KNEE_ANKLE_METHOD_KEY_RANGE[that.selectedExerciseProps.exerciseGuide.exerciseGuideDeviceLoh].trans) : '-';
                break;
            default :
                break;
        }

        let gripLoh = {
            index: 13,
            keyTitle: gripLohValue.keyTitle,
            keyType: 'DefaultInfoInput',
            class: '',
            keyRange: [],
            values: gripLohValue.values,
        };

        switch (mode) {
            case ENUM.EXERCISE_MODE.ACTIVE : {
                items = [
                    ...items,
                    gripLoh,
                    {
                        index: 6,
                        keyTitle: that.$t('rehabilitation.up'),
                        keyType: 'DefaultInfoInput',
                        class: '',
                        keyRange: [],
                        values: getActiveModeAssistValues(that, that.selectedExerciseProps.exerciseGuide.exerciseGuideFlexion)
                    }, {
                        index: 7,
                        keyTitle: that.$t('rehabilitation.down'),
                        keyType: 'DefaultInfoInput',
                        class: '',
                        keyRange: [],
                        values: getActiveModeAssistValues(that, that.selectedExerciseProps.exerciseGuide.exerciseGuideExtension)
                    },
                ];
                break;
            }
            case ENUM.EXERCISE_MODE.PASSIVE : {
                items = [
                    ...items,
                    gripLoh,
                    {
                        index: 6,
                        keyTitle: that.$t('rehabilitation.speed'),
                        keyType: 'DefaultInfoInput',
                        class: '',
                        keyRange: [],
                        values: getPassiveModeUnitValues(that, that.selectedExerciseProps.exerciseGuide.exerciseGuideSpeed)
                    }
                ];
                break;
            }
            case ENUM.EXERCISE_MODE.PASSIVE_MEASURE :
            case ENUM.EXERCISE_MODE.ACTIVE_MEASURE : {
                items = [
                    ...items,
                    gripLoh,
                    {
                        index: 8,
                        keyTitle: that.$t('rehabilitation.additional_notes'),
                        keyType: 'DefaultInfoInput',
                        class: 'custom-memo',
                        parentClass: ['columns_4', 'rehab_memo'],
                        keyRange: [],
                        values: that.selectedExerciseProps.exerciseGuide.exerciseGuideContext,
                    }
                ];
                return items;
            }
            default : {
                break;
            }
        }
        const commonItems = [
            {
                index: 8,
                keyTitle: that.$t('rehabilitation.reps'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideCount
            }, {
                index: 9,
                keyTitle: that.$t('rehabilitation.time'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.moment.utc(that.moment.duration(that.selectedExerciseProps.exerciseGuide.exerciseGuideTime, "second").asMilliseconds()).format('HH:mm:ss')
            }, {
                index: 10,
                keyTitle: that.$t('rehabilitation.min_rom'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideMinRom + that.$t('unit.deg')
            }, {
                index: 11,
                keyTitle: that.$t('rehabilitation.max_rom'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideMaxRom + that.$t('unit.deg')
            }, {
                index: 12,
                keyTitle: that.$t('rehabilitation.additional_notes'),
                keyType: 'DefaultInfoInput',
                parentClass: ['columns_4', 'rehab_memo'],
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideContext,
                mainStyle: {
                    height: '100%',
                },
                titleStyle: {
                    // flex: '1 1 1rem',
                },
                style: {}
            }
        ];

        items.push.apply(items, commonItems);
    } else {
        let tempData = [];

        const setActive = () => {
            tempData.push({
                index: 15,
                keyTitle: that.$t('rehabilitation.up_max'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideFlexionLimitTime,
            })
            tempData.push({
                index: 16,
                keyTitle: that.$t('rehabilitation.down_max'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideExtensionLimitTime,
            })
        }
        const setPassive = () => {
            tempData.push({
                index: 13,
                keyTitle: that.$t('rehabilitation.up_delay'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideFlexionDelayTime,
            })
            tempData.push({
                index: 14,
                keyTitle: that.$t('rehabilitation.down_delay'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideExtensionDelayTime,
            })
            tempData.push({
                index: 10,
                keyTitle: that.$t('rehabilitation.speed'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that?.selectedExerciseProps?.exerciseGuide?.exerciseGuideSpeed,
            })
        }
        const setRomGuide = () => {
            switch (position) {
                case ENUM.POSITION.ELBOW :
                    break;
                case ENUM.POSITION.WRIST :
                    break;
                case ENUM.POSITION.KNEE :
                    tempData.push({
                        // 최저 ROM
                        index: 17,
                        keyTitle: that.$t('rehabilitation.min_rom'),
                        keyType: 'DefaultInfoInput',
                        class: '',
                        keyRange: [],
                        values: that.selectedExerciseProps.exerciseGuide.exerciseGuideKneeMinRom + that.$t('unit.deg'),
                    })
                    tempData.push({
                        // 최고 ROM
                        index: 18,
                        keyTitle: that.$t('rehabilitation.max_rom'),
                        keyType: 'DefaultInfoInput',
                        class: '',
                        keyRange: [],
                        values: that.selectedExerciseProps.exerciseGuide.exerciseGuideKneeMaxRom + that.$t('unit.deg'),
                    })
                    break;
                case ENUM.POSITION.ANKLE :
                    tempData.push({
                        // 최저 ROM
                        index: 17,
                        keyTitle: that.$t('rehabilitation.min_rom'),
                        keyType: 'DefaultInfoInput',
                        class: '',
                        keyRange: [],
                        values: that.selectedExerciseProps.exerciseGuide.exerciseGuideAnkleMinRom + that.$t('unit.deg'),
                    })
                    tempData.push({
                        // 최고 ROM
                        index: 18,
                        keyTitle: that.$t('rehabilitation.max_rom'),
                        keyType: 'DefaultInfoInput',
                        class: '',
                        keyRange: [],
                        values: that.selectedExerciseProps.exerciseGuide.exerciseGuideAnkleMaxRom + that.$t('unit.deg'),
                    })
                    break;
                default :
                    break;
            }
        }

        switch (mode) {
            case ENUM.EXERCISE_MODE.ACTIVE : {
                setRomGuide();
                tempData.push({
                    index: 11,
                    keyTitle: that.$t('rehabilitation.up'),
                    keyType: 'DefaultInfoInput',
                    class: '',
                    keyRange: [],
                    values: getActiveModeAssistValues(that, that.selectedExerciseProps.exerciseGuide.exerciseGuideFlexion),
                })
                tempData.push({
                    index: 12,
                    keyTitle: that.$t('rehabilitation.down'),
                    keyType: 'DefaultInfoInput',
                    class: '',
                    keyRange: [],
                    values: getActiveModeAssistValues(that, that.selectedExerciseProps.exerciseGuide.exerciseGuideExtension),
                })
                setActive();
                break;
            }
            case ENUM.EXERCISE_MODE.ACTIVE_MEASURE : {
                setActive();
                break;
            }
            case ENUM.EXERCISE_MODE.PASSIVE : {
                setRomGuide();
                setPassive();
                break;
            }
            case ENUM.EXERCISE_MODE.PASSIVE_MEASURE : {
                setPassive();
                break;
            }
            default :
                break;
        }

        items = [
            ...tempData,
            {
                // 저항 민감도
                index: 8,
                keyTitle: that.$t('rehabilitation.resistance_sensitivity'),
                keyType: 'DefaultInfoInput',
                class: '',
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideMuscleStiffSensitive + '/ 10',
            },
            {
                // 내용
                index: 9,
                keyTitle: that.$t('rehabilitation.additional_notes'),
                keyType: 'DefaultInfoInput',
                class: 'custom-memo',
                parentClass: ['columns_4', 'rehab_memo'],
                keyRange: [],
                values: that.selectedExerciseProps.exerciseGuide.exerciseGuideContext,
            }
        ];
    }

    return items;
};